import { render } from "./AddLeaveRecordModal.vue?vue&type=template&id=24830f54"
import script from "./AddLeaveRecordModal.vue?vue&type=script&lang=js"
export * from "./AddLeaveRecordModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__